module.exports = __webpack_public_path__ + "img/beginners-series_3x4_poster.c91a7f2.jpg";